export interface Faq {
  q: string
  a: string
}

export const faqs: Faq[] = [
  {
    q: 'How do I receive the package after purchase?',
    a: 'You get instant access to all materials so you can start using them immediately — no waiting, no complicated steps. Everything downloads as ready-to-use PDFs on your device.',
  },
  {
    q: 'What teaching level is this for?',
    a: 'For anyone who teaches mindfulness and meditation: from teachers new to the practice needing ready-to-use systems, to experienced instructors wanting to save hours on planning.',
  },
  {
    q: 'Does this work for teachers in any country?',
    a: 'Completely. The material is designed to be universal in its application to any context, region, language, or culture. You can freely adapt it to your local teaching.',
  },
  {
    q: 'Can I edit and modify the material?',
    a: 'Absolutely. The material is yours to use, adapt, and modify however works best for your teaching. It is completely flexible.',
  },
  {
    q: 'What currency will I pay in?',
    a: 'Your local currency. The system automatically detects your country and charges in the appropriate currency. No currency conversion surprises.',
  },
  {
    q: 'What if it does not work for me?',
    a: 'You have a full 7 days. If the material is not useful, clear, or practical for your needs, contact us and we will refund everything with no questions asked.',
  },
  {
    q: 'Is this video-based content?',
    a: 'No, it is completely PDF-based content. It is designed so you can read it, use it, print it, and bring it directly to class with you.',
  },
  {
    q: 'Can I teach this material to other teachers?',
    a: 'No. The purchase is for your personal use as a teacher. It does not include redistribution rights.',
  },
  {
    q: 'How do I download everything?',
    a: 'After purchase, you will receive immediate access to a secure download page where you can get all materials. They are organized and ready to use.',
  },
  {
    q: 'Is there an expiration date on my access?',
    a: 'No. Once purchased, you have permanent access to all materials and any future updates included.',
  },
]
